import { observer } from "mobx-react";
import * as React from "react";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { getLogs } from "../../actions/getLogs";
import { logFilterTypes } from "../../data/logFilterTypes";
import { lang } from "../../lang";
import { Log, TableTransformParam } from "../../interface";
import { store } from "../../store";
import { ROUTE_TYPE, pad } from "../../HelperSrc";
import { CenteredContent } from "../../components/atoms/CenteredContent";
import { FlexHorizontal, FlexSpacer } from "../../components/atoms/Flex";
import { Title } from "../../components/atoms/Text";
import { Dropdown } from "../../components/molecules/Dropdown";
import { Table } from "../../components/molecules/Table";
import { Template } from "../../components/organisms/Template";
import ArrowDownIcon from "@mui/icons-material/ArrowDropDownOutlined";

@observer
class LogsPageBase extends React.Component<RouteComponentProps> {
    public state = {
        totalItems: 0,
        results: [] as Log[],
        id: 0,
        value: "",
        name: lang.all,
        count: 1,
        loading: false,
        pageSize: 0
    };
    public componentDidMount(): void {
        if (!store.db) {
            store.doNotice(lang.selectClientAlert);
            this.props.history.replace(ROUTE_TYPE.CLIENTS);
            return;
        }
        this.loadPage(1);
    }
    public filterLog = async (id: number, filterValue?: string): Promise<void> => {
        if (filterValue && filterValue === "All") {
            filterValue = "";
        }
        this.setState({
            id,
            results: [] as Log[],
            value: filterValue,
            loading: true
        });
        const lg = await getLogs(id, filterValue);
        if (!lg) return;

        const results = this.state.results;
        lg.results.forEach((e, i) => {
            results[i + (id - 1) * lg.page_size] = e;
        });
        this.setState({
            results,
            totalItems: lg.count,
            loading: false,
            pageSize: lg.page_size
        });
    };
    public loadPage = (id: number, filterValue?: string): void => {
        this.filterLog(id, filterValue).catch(() => {
            store.doNotice("Filter log: An unexpected error occurred");
        });
    };
    public render(): React.ReactElement {
        return (
            <Template>
                <CenteredContent>
                    <FlexHorizontal>
                        <Title>{lang.auditLogs}</Title>
                        <FlexSpacer />
                        <div className="logs_Blue">
                            <Dropdown
                                icon={ArrowDownIcon}
                                iconRight={true}
                                title={this.state.name}
                                data-at_id="log_filter"
                                items={logFilterTypes()}
                                onClick={(currFilter) => {
                                    const current = currFilter;
                                    this.filterLog(1, current.key).catch(() => {
                                        store.doNotice("Filter log: An unexpected error occurred");
                                    });
                                    this.state.count === 1
                                        ? this.setState({
                                              name: current.name,
                                              count: 2
                                          })
                                        : this.setState({
                                              name: current.name,
                                              count: 1
                                          });
                                    this.filterLog(1, current.key).catch(() => {
                                        store.doNotice("Filter log: An unexpected error occurred");
                                    });
                                    store.doNotice(lang.filteredLog, true);
                                }}
                                menuWidth={150}
                            />
                        </div>
                    </FlexHorizontal>
                    <Table
                        key={`${this.state.value}${this.state.count}`}
                        data-at_id="admin_logs_tbl"
                        loading={this.state.loading}
                        pageSize={this.state.pageSize}
                        totalItems={this.state.totalItems}
                        columnNames={[
                            {
                                id: "created",
                                name: lang.date,
                                transform: (e: TableTransformParam) => {
                                    const dt = new Date(String(e));
                                    return `${dt.getFullYear()}-${pad(String(dt.getMonth() + 1))}-${pad(String(dt.getDate()))} ${pad(
                                        String(dt.getHours())
                                    )}:${pad(String(dt.getMinutes()))}`;
                                },
                                width: "180px"
                            },
                            { id: "message", name: lang.message }
                        ]}
                        data={this.state.results}
                        onPageChange={(e) => {
                            this.loadPage(e, this.state.value);
                        }}
                    />
                </CenteredContent>
            </Template>
        );
    }
}

const LogsPage = withRouter(LogsPageBase);

export { LogsPage };
